module.exports = __webpack_public_path__ + "img/lkz_ico_45.a97c17d9.svg";